class CartNotification extends HTMLElement {
  constructor() {
    super();

    setTimeout(() => {
      this.notification = document.getElementById('cart-notification');
      this.header = document.querySelector('sticky-header');
      this.onBodyClick = this.handleBodyClick.bind(this);

      // Süreyi HTML’den alabilir (örn. data-timeout="7000"), yoksa 5000 ms varsayılan.
      const attrTimeout = parseInt(this.notification?.getAttribute('data-timeout') || '', 10);
      this.timeoutMs = Number.isFinite(attrTimeout) ? attrTimeout : 5000;

      this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.close();
        })
      );

      // (İsteğe bağlı) Hover sırasında duraklatma:
      // this.notification.addEventListener('mouseenter', this.pauseTimer.bind(this));
      // this.notification.addEventListener('mouseleave', this.resumeTimer.bind(this));
    }, 1000);
  }

  clearAutoClose() {
    if (this.autoCloseTimeout) {
      clearTimeout(this.autoCloseTimeout);
      this.autoCloseTimeout = null;
    }
  }

  restartAutoClose() {
    this.clearAutoClose();
    this.autoCloseStartedAt = Date.now();
    this.remainingMs = this.timeoutMs;
    this.autoCloseTimeout = setTimeout(() => this.close(), this.remainingMs);
  }

  // (İsteğe bağlı) Hover desteği:
  pauseTimer() {
    if (!this.autoCloseTimeout) return;
    clearTimeout(this.autoCloseTimeout);
    this.autoCloseTimeout = null;
    const elapsed = Date.now() - (this.autoCloseStartedAt || Date.now());
    this.remainingMs = Math.max(0, (this.remainingMs ?? this.timeoutMs) - elapsed);
  }

  resumeTimer() {
    if (this.notification?.classList.contains('active') && (this.remainingMs ?? 0) > 0) {
      this.autoCloseStartedAt = Date.now();
      this.autoCloseTimeout = setTimeout(() => this.close(), this.remainingMs);
    }
  }

  open() {
    // Bildirimi görünür yap
    this.notification.classList.add('animate', 'active');

    // Her açılışta zamanlayıcıyı sıfırla (önceki varsa temizle)
    this.restartAutoClose();

    // Focus ve trapFocus işlemi
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus();

    this.clearAutoClose();
    this.remainingMs = this.timeoutMs;
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    if (this.header) this.header.reveal();

    // İçerik her yenilendiğinde open() çağrılır → süre yeniden başlar.
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
